import { Fragment } from "react"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import Enconstruccion from "../Blog/Enconstruccion"
import Home from "../Blog/Home.blog"
import LayoutBlog from "../Blog/Layout.blog"
import ArticuloAhorro from "../Blog/Articulo1.blog"
import InicioLibro from "../Blog/Libro/Inicio"
import Page404 from "../Blog/Page404"
import AgregarArticulo from "../Blog/AgregarArticulo"
import TemplateCapitulo from "../Blog/Libro/TemplateCapitulo"
import Login from "../Blog/Login"
import Registrarse from "../Blog/Registrarse"
import ActivarUsuario from "../Blog/ActivarUsuario"


const Rutas = () => {


    return (
        <Router>
            <Routes>
                {/* Layout del blog */}
                <Route element={<LayoutBlog />}>

                    <Route path="/" element={<Home />} />
                    <Route path="/libro" element={<InicioLibro />} />
                    <Route path="/agregar-articulo" element={<AgregarArticulo/>} />
                    <Route path="/ahorro" element={<ArticuloAhorro />} />
                    <Route path="/libro/capitulo/:slug" element={<TemplateCapitulo />} />
                    <Route path="/iniciar-sesion" element={<Login />} />
                    <Route path="/registrarse" element={<Registrarse />} />
                    <Route path="/activar-usuario/:codigo" element={<ActivarUsuario />} />

                    
                </Route>
                <Route path="*" element={<Page404 />} />


            </Routes>
        </Router>
    )



}

export default Rutas